export function getInputStyles(theme, breakpoint) {
    const isMobile = breakpoint === "mobile";
    return {
        wrapper: {
            display: "flex",
            flexDirection: "column",
            gap: "6px",
        },
        label: {
            fontSize: "14px",
            fontWeight: 500,
            color: theme.colors.text,
        },
        labelRequired: {
            color: theme.colors.error,
        },
        input: {
            width: "100%",
            height: isMobile ? "36px" : "40px",
            padding: isMobile ? "0 10px" : "0 12px",
            fontSize: isMobile ? "13px" : "14px",
            color: theme.colors.text,
            backgroundColor: theme.colors.surface,
            borderWidth: "1px",
            borderStyle: "solid",
            borderColor: theme.colors.border,
            borderRadius: isMobile ? "8px" : "10px",
            outline: "none",
            transition: "border-color 0.2s ease, box-shadow 0.2s ease",
            boxSizing: "border-box",
        },
        inputFocus: {
            borderColor: theme.colors.primary,
            boxShadow: `0 0 0 3px ${theme.colors.primary}20`,
        },
        inputError: {
            borderColor: theme.colors.error,
        },
        inputDisabled: {
            backgroundColor: theme.colors.backgroundSecondary,
            cursor: "not-allowed",
            opacity: 0.7,
        },
        textarea: {
            width: "100%",
            minHeight: "100px",
            padding: "12px",
            fontSize: "14px",
            color: theme.colors.text,
            backgroundColor: theme.colors.surface,
            borderWidth: "1px",
            borderStyle: "solid",
            borderColor: theme.colors.border,
            borderRadius: "10px",
            outline: "none",
            resize: "vertical",
            transition: "border-color 0.2s ease, box-shadow 0.2s ease",
            boxSizing: "border-box",
        },
        helperText: {
            fontSize: "12px",
            color: theme.colors.textSecondary,
        },
        errorText: {
            fontSize: "12px",
            color: theme.colors.error,
        },
        otpContainer: {
            display: "flex",
            gap: "8px",
            justifyContent: "center",
        },
        otpInput: {
            width: "48px",
            height: "56px",
            textAlign: "center",
            fontSize: "24px",
            fontWeight: 600,
            color: theme.colors.text,
            backgroundColor: theme.colors.surface,
            borderWidth: "2px",
            borderStyle: "solid",
            borderColor: theme.colors.border,
            borderRadius: "8px",
            outline: "none",
            transition: "border-color 0.2s ease",
        },
        otpInputFocus: {
            borderColor: theme.colors.primary,
        },
    };
}
